import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueMaterial from 'vue-material'

Vue.use(VueMaterial)

Vue.config.productionTip = false

export const eventBus = new Vue()

import SocialSharing from 'vue-social-sharing'
import vuetify from './plugins/vuetify'
Vue.use(SocialSharing)

import VueExpandableImage from 'vue-expandable-image'
Vue.use(VueExpandableImage)

import LoadScript from 'vue-plugin-load-script'
Vue.use(LoadScript)

import VueMask from 'v-mask'
Vue.use(VueMask)


// let lastAccess = sessionStorage.getItem('lastAccess')

// if (!lastAccess) {
//   sessionStorage.setItem('lastAccess', new Date().getTime())
//   location.reload(true)
// } else {
//   // if last access more than 5 hours ago (milliseconds) get fresh copy of assets
//   if (Date.now() - lastAccess > 18000000) {
//     sessionStorage.setItem('lastAccess', new Date().getTime())
//     location.reload(true)
//   }
// }

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')

